/* eslint-disable @typescript-eslint/no-explicit-any */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import * as moment from 'moment';

@Injectable()
export class ConfigService {
  configURL = 'assets/config/config.json';
  appConfig: any;

  constructor(private http: HttpClient) {}

  loadAppConfig() {
    return firstValueFrom(this.http.get(this.configURL)).then((data) => {
      const startDate = moment()
        .subtract(data['dataRangeInDays'], 'days')
        .format('YYYY-MM-DD');

      const noTrackingBool =
        data['noTracking'] === 'true' || data['noTracking'] === true;
      const reportsDisabledBool =
        data['reportsDisabled'] === 'true' || data['reportsDisabled'] === true;
      const enableAIBannerBool =
        data['enableAIBanner'] === 'true' || data['enableAIBanner'] === true;
      const enableEmployeeAuthTokenBool =
        data['enableEmployeeAuthToken'] === 'true' ||
        data['enableEmployeeAuthToken'] === true;
      this.appConfig = {
        version: data['version'],
        environment: data['environment'],
        production: data['production'],
        urlDataApi: data['urlDataApi'],
        urlMetadataApi: data['urlMetadataApi'],
        urlCustomerApi: data['urlCustomerApi'],
        urlCustomerPortal: data['urlCustomerPortal'],
        urlQuantApi: data['urlQuantApi'],
        urlChatLLMApi: data['urlChatLLMApi'],
        urlNewsletterApi: data['urlNewsletterApi'],
        urlReportingServiceApi: data['urlReportingServiceApi'],
        urlSentry: data['urlSentry'],
        urlLoginRedirect: data['urlLoginRedirect'],
        routing: {
          name: data['routing']['name'],
          theme: data['routing']['theme'],
          apiproj: data['routing']['apiproj'],
          authpro: data['routing']['authpro'],
          project: data['routing']['project'],
        },
        setup: {
          // startDate: startDate ? startDate : data['startDate']
          startDate: startDate,
          noTracking: noTrackingBool,
          reportsDisabled: reportsDisabledBool,
          enableAIBanner: enableAIBannerBool,
          enableEmployeeAuthToken: enableEmployeeAuthTokenBool,
        },
      };

      if (this.isLocalStorageAvailable()) {
        this.appConfig.setup.useStorage = true;
      } else {
        this.appConfig.setup.useStorage = false;
      }
    });
  }

  isLocalStorageAvailable() {
    const test = 'test';
    try {
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  }
}
